<template>
	<div>
		<el-row>
            <el-col :span="12">
              <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="150px" class="mt20">

                <el-form-item :label="$t('lin_global.otaName')" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item :label="$t('terminal.appBind.label_version')" prop="version">
                  <el-input v-model="form.version"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lin_global.risk_desc')" prop="memo">
                  <el-input v-model="form.memo"></el-input>
                </el-form-item>
				<!--moidfy by sing,2017-09-28;取消OTA和ROM的区分，统一改为OTA更新-->
				<!--<el-form-item :label="$t('lin_global.xtlx')" prop="type">
				    <el-radio-group v-model="form.type">
				      <el-radio label="rom">{{$t('lin_global.syatemR')}}</el-radio>
				      <el-radio label="ota">{{$t('lin_global.sysjota')}}</el-radio>
				    </el-radio-group>
				</el-form-item>-->
				<el-form-item :label="$t('lin_global.xgscwj')" prop="filePath">
				    <el-upload
					  class="upload-demo"
					  name="fileUpload"
					  drag
					  :action="action"
					  :on-success="handleAvatarScucess"
					  :before-upload="beforeAvatarUpload">
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">{{$t('lin_global.jwjtdcc')}}<em>{{$t('lin_global.djsc')}}</em></div>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.qsczipwjls50')}}</div>
					</el-upload>
			    </el-form-item>
					<el-form-item :label="$t('app_udfiletype')" prop="">
					  <el-radio class="radio" v-model="form.updateType" label="0">{{$t('app_ttPkg')}}</el-radio>
 					  <el-radio class="radio" v-model="form.updateType" label="1">{{$t('app_dfPkg')}}</el-radio>
					</el-form-item>
			    <el-form-item :label="$t('lin_global.azbdz')">
                  	<el-input v-model="form.filePath"></el-input>
                </el-form-item>

                <!-- <el-form-item :label="$t('lin_global.qmzst')">
                  <el-checkbox v-model="checked" @change="check">{{$t('lin_global.sfsyzdqm')}}</el-checkbox>
                </el-form-item> -->

                <el-form-item :label="$t('lin_global.zdqds')" prop="mechanismId">
                    <!--<el-select id="mechanismId" v-model="form.mechanismId" filterable clearable :placeholder="$t('lin_global.place_areaid')" style="width:100%">-->
                       <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
                       <!--</el-option>-->
                    <!--</el-select>-->

                  <MechanismSelector v-if="mechanismData.value" :data="mechanismData" :mselect="true" ></MechanismSelector>
                </el-form-item>

                <el-form-item>
                  <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
                  <el-button type="primary" @click="onSubmit">{{$t('lin_btn.add')}}</el-button>
                </el-form-item>

              </el-form>
            </el-col>

        </el-row>

	</div>

</template>
<style>
  [v-cloak] {
    display: none;
  }
</style>
<script>
	import axios from 'axios'
  import { baseurl,urlAssets } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
		data(){
		  var that = this
			return{
        mechanismData: {
          value: null,
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.mechanismId = value
          }
        },
				checked: false,
        action:`${urlAssets.fileUrl}`,
				form:{
					id: this.$route.params.id,
					status:'0',
					name:'',
					md5: '',
					version:'',
          memo:'',
					type:'ota',
					autoSign:'1',
					mechanismId:'',
					filePath:'',
					updateType: ''
				},
				rules:{
					'name':[{
						required: true,
		            	message: this.$t('lin_global.notBlankName')
					}],
					'version':[{
						required: true,
		            	message: this.$t('lin_global.notBlankVer')
					}],
					'type':[{
						required: true,
		            	message: this.$t('lin_global.qxzlx')
					}],
					'filePath':[{
						required: true,
		            	message: this.$t('lin_global.qxzscwj')
					}]
				},
				areaList:[]
			}
		},
		created(){ 
			this.getDetail();
		},
		methods:{
			check:function(){
				if(this.checked){
					this.form.autoSign = '0'
				}else{
					this.form.autoSign = '1'
				}
			},
			handleAvatarScucess(res, file) {
		        //console.log("打印上传后返回");
		        //console.log(res);
						this.form.filePath = res.fileUrl;
						this.form.md5 = res.md5
		    },
		    beforeAvatarUpload(file) {

		    },
			getAd:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		var obj={
		    			'mechanismname':this.$t('lin_global.syqdsty'),
		    			'mechanismid':''
		    		}
		    		this.areaList = res.data.data;

		    		this.areaList.unshift(obj)
		    	})
		    },
			getDetail:function(){
				var romId = this.$route.params.id;
				var params = {id:romId};
				axios.post(`${baseurl}/ota_rom/detail.do`,params).then(res=>{
					//console.log(res.data);
					if(res.data.status == 200){
						this.form.name = res.data.data.name;
						this.form.version = res.data.data.version;
            this.form.memo = res.data.data.memo;
						this.form.type = res.data.data.type;
						this.form.updateType = res.data.data.updateType
						if(res.data.data.autosign == 0){
							this.checked = true;
						}else{
							this.checked = false;
						}
						this.form.mechanismId = res.data.data.mechanismId;

            this.mechanismData.value = res.data.data.mechanismId

            console.log(this.mechanismData.value)
            console.log(this.mechanismData.value)
            console.log(this.mechanismData.value)
						this.form.filePath = res.data.data.path;
					}
				})
			},
			onSubmit:function(){
				var params = this.form;
				params.md5 = this.form.md5
				//console.log("打印传入参数");
				console.log('ppp', params)
				axios.post(`${baseurl}/ota_rom/edit.do`,params).then(res=>{
		            //console.log("打印看看登陆信息")
		            //console.log(res.data);
		            if(res.data.status == 200){
		            	this.$message.success(res.data.message);
		            	this.$router.go(-1);
		            }else{
		            	this.$message.error(res.data.message)
		            }
		        })
			},
			onCancel:function(){
				this.$router.go(-1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// romEdit.vue?68d92a85